<template>
<div style="width: 1000px;margin: auto"><p style="text-indent:43px">
    <strong><span style="font-size:21px">&nbsp;</span></strong>
</p>
<p style="text-indent:43px">
    <strong><span style="font-size:21px">&nbsp;</span></strong>
</p>
<p style="text-indent:43px">
    <strong><span style="font-size:21px">&nbsp;</span></strong>
</p>
<p style="text-indent:43px">
    <strong><span style="font-size:21px">&nbsp;</span></strong>
</p>
<p style="margin-top:10px;margin-right:0;margin-bottom:10px;margin-left:0;text-align:center;line-height:200%">
    <strong><span style="font-size:37px;line-height:200%;font-family: 黑体">中国中小企业诚信服务联盟</span></strong>
</p>
<p style="text-align:center;line-height:115%">
    <strong><span style="font-size:37px;line-height:115%;font-family:黑体">章&nbsp; 程</span></strong>
</p>
<p style="text-indent:43px">
    <strong><span style="font-size:21px;font-family:黑体">&nbsp;</span></strong>
</p>

<p style="text-indent:43px">
    <strong><span style="font-size:21px;font-family:黑体">&nbsp;</span></strong>
</p>
<p style="text-indent:43px">
    <strong><span style="font-size:21px;font-family:黑体">&nbsp;</span></strong>
</p>
<p style="text-indent:43px">
    <strong><span style="font-size:21px;font-family:黑体">&nbsp;</span></strong>
</p>
<p style="text-align:center">
    <strong><span style="font-size:21px;font-family:仿宋">第一章<span style="font:9px &#39;Times New Roman&#39;">&nbsp; </span></span></strong><strong><span style="font-size:21px;font-family: 仿宋">总则</span></strong>
</p>
<p style="margin-left:120px">
    <strong><span style="font-size:21px;font-family:仿宋">&nbsp;</span></strong>
</p>
<p style="margin-left:0;text-indent:37px">
    <strong><span style="font-size:19px;font-family:仿宋">第一条</span></strong> <span style="font-size:19px;font-family:仿宋">本联盟由中国中小企业信息网发起成立，名称为中国中小企业诚信服务联盟。</span>
</p>
<p style="margin-left:0;text-indent:37px">
    <strong><span style="font-size:19px;font-family:仿宋">第二条</span></strong> <span style="font-size:19px;font-family:仿宋">本联盟是在遵守国家相关法律法规的前提下，由全国中小企业管理部门、中小企业服务机构、金融机构、知名征信机构、大数据服务企业、诚信应用企业以及诚信领域相关专家、学者等组成的自律性组织，在宪法和法律法规及国家政策应允的范围内开展工作。</span>
</p>
<p style="margin-left:0;text-indent:37px">
    <strong><span style="font-size:19px;font-family:仿宋">第三条</span></strong> <span style="font-size:19px;font-family:仿宋">本联盟的宗旨是：在遵守国家相关法律、法规和经济政策的基础上，认真贯彻落实国务院《社会信用体系建设规划纲要（2014—2020年）》（国发〔2014〕21号）中关于推进中小企业信用体系建设的精神。以中小企业信用体系建设为行动准则，围绕提高中小企业诚信水平为中心工作。组建一支服务于中小企业信用服务的专业队伍，构架起联盟与中小企业之间沟通的桥梁，为中小企业搭建多层次、多元化的服务平台，影响和带动广大中小企业通过信用体系建设有效维护商务关系、有效降低商务运行成本、有效改善营商环境，促进中小企业的健康、稳步可持续发展。</span>
</p>
<p style="margin-left:0;text-indent:37px">
    <strong><span style="font-size:19px;font-family:仿宋">第四条</span></strong> <span style="font-size:19px;font-family:仿宋">本联盟接受相关业务主管单位的业务指导和监督管理。</span>
</p>
<p style="margin-left:0;text-indent:37px">
    <strong><span style="font-size:19px;font-family:仿宋">第五条</span></strong> <span style="font-size:19px;font-family:仿宋">本联盟的办公地设在中国北京市。</span>
</p>
<p style="margin-left:37px">
    <span style="font-size:19px;font-family:仿宋">&nbsp;</span>
</p>
<p style="text-align:center;text-indent:43px">
    <strong><span style="font-size:21px;font-family:仿宋">第二章&nbsp; 职责范围</span></strong>
</p>
<p style="text-indent:37px;vertical-align:baseline">
    <strong><span style="font-size:19px;font-family:仿宋">第六条</span></strong><span style="font-size:19px;font-family:仿宋"> 本联盟根据国家相关法律法规的有关规定，行使下列职责：</span>
</p>
<p style="text-indent:37px;vertical-align:baseline">
    <span style="font-size: 19px;font-family:仿宋">（一）依托各自资源优势，共同参与到中小企业诚信服务相关活动之中。</span>
</p>
<p style="text-align:left;text-indent:37px">
    <span style="font-size:19px;font-family:仿宋">（二）整合全国中小企业管理部门、中小企业服务机构、金融机构、知名征信机构、大数据服务企业、诚信应用企业以及诚信领域相关专家、学者等资源，打造中小企业诚信平台，为联盟成员和中小企业搭建专业对接平台，为联盟成员内部提供高效信息交流服务；</span>
</p>
<p style="text-align:left;text-indent:37px">
    <span style="font-size:19px;font-family:仿宋">（三）发挥联盟在成员与政府主管部门间的桥梁和纽带作用，反映业内诉求和建议，维护成员的合法权益和公平的市场环境；</span>
</p>
<p style="text-align:left;text-indent:37px">
    <span style="font-size:19px;font-family:仿宋">（四）统计联盟服务机构具体服务内容和中小企业需求。根据中小企业需求，推荐相关联盟服务机构为其提供有针对性和专业性服务。</span>
</p>
<p style="text-align:left;text-indent:37px">
    <span style="font-size:19px;font-family:仿宋">（五）针对有同质性需求的中小企业，开展线下服务对接会，监督并推进合作进行。</span>
</p>
<p style="text-align:left;text-indent:37px">
    <span style="font-size:19px;font-family:仿宋">（六）参与各种形式的线上线下活动，推进中小企业诚信体系建设，搭建沟通、推广和交流的平台。</span>
</p>
<p style="text-align:left;text-indent:37px">
    <span style="font-size:19px;font-family:仿宋">（七）其他符合联盟成员共同利益的有关事项。</span>
</p>
<p style="text-align:left;text-indent:37px">
    <span style="font-size:19px;font-family: 仿宋">&nbsp;</span>
</p>
<p style="text-align:center;text-indent:43px">
    <strong><span style="font-size:21px;font-family:仿宋">第三章&nbsp; 联盟成员管理</span></strong>
</p>
<p style="text-align:left;text-indent:37px">
    <strong><span style="font-size:19px;font-family:仿宋">第七条 </span></strong><span style="font-size: 19px;font-family:仿宋">加入联盟成员的服务机构或企业单位应具备以下条件： </span>
</p>
<p style="text-align:left;text-indent:37px">
    <span style="font-size:19px;font-family:仿宋">（一）承认本联盟章程；</span>
</p>
<p style="text-align:left;text-indent:37px">
    <span style="font-size:19px;font-family:仿宋">（二）热心支持中小企业发展，自愿加入联盟并积极履行联盟成员的各项义务；</span>
</p>
<p style="text-align:left;text-indent:37px">
    <span style="font-size:19px;font-family:仿宋">（三）依法登记注册、管理规范、诚实守信、业绩突出，在行业内有一定的知名度和影响力。</span>
</p>
<p style="text-align:left;text-indent:37px">
    <strong><span style="font-size:19px;font-family:仿宋">第八条 </span></strong><span style="font-size: 19px;font-family:仿宋">联盟成员的权利</span>
</p>
<p style="text-align:left;text-indent:37px">
    <span style="font-size:19px;font-family:仿宋">（一）联盟成员享有选举权、被选举权和表决权；</span>
</p>
<p style="text-align:left;text-indent:37px">
    <span style="font-size:19px;font-family:仿宋">（二）联盟成员享有参与联盟理事代表大会的权力；</span>
</p>
<p style="text-align:left;text-indent:37px">
    <span style="font-size:19px;font-family:仿宋">（三）联盟成员享有参加联盟组织的专题会、论坛、研讨会、信息交流及考察等活动的权力；</span>
</p>
<p style="text-align:left;text-indent:37px">
    <span style="font-size:19px;font-family:仿宋">（四）联盟专有服务：给予联盟成员经营业务向经过重点筛选的中小企业推荐服务项目；对联盟内部有合作需求的企业进行推荐对接。</span>
</p>
<p style="text-align:left;text-indent:37px">
    <span style="font-size:19px;font-family:仿宋">（五）联盟成员享有优先、优惠在中国中小企业信息网及微信公众号等进行宣传发布和业务推广权；</span>
</p>
<p style="text-align:left;text-indent:37px">
    <span style="font-size:19px;font-family:仿宋">（六）联盟成员享有对联盟的组织和服务工作的批评建议权和监督权；</span>
</p>
<p style="text-align:left;text-indent:37px">
    <span style="font-size:19px;font-family:仿宋">（七）加入联盟自愿，退出联盟自由。</span>
</p>
<p style="text-align:left;text-indent:37px">
    <strong><span style="font-size:19px;font-family:仿宋">第九条</span></strong><span style="font-size: 19px;font-family:仿宋"> 联盟成员的义务： </span>
</p>
<p style="text-align:left;text-indent:37px">
    <span style="font-size:19px;font-family:仿宋">（一）联盟成员有义务遵守国家法律和联盟章程，执行联盟决议，维护联盟的声誉和利益；</span>
</p>
<p style="text-align:left;text-indent:37px">
    <span style="font-size:19px;font-family:仿宋">（二）联盟成员有义务积极参加联盟组织的活动，履行联盟章程规定的义务与相关委托事项；</span>
</p>
<p style="text-align:left;text-indent:37px">
    <span style="font-size:19px;font-family:仿宋">（三）联盟成员有义务尽量为联盟贡献自身机构的优势资源、服务内容及专业能力；</span>
</p>
<p style="text-align:left;text-indent:37px">
    <span style="font-size:19px;font-family:仿宋">（四）联盟成员有义务对联盟提供的有关企业信息资料，严格保密，不得翻印、转卖、发表或以其他方式泄漏；</span>
</p>
<p style="text-align:left;text-indent:37px">
    <span style="font-size:19px;font-family:仿宋">（五）联盟成员未经授权，不得单独以联盟的名义办理业务、举办活动或发表言论；</span>
</p>
<p style="text-align:left;text-indent:37px">
    <span style="font-size:19px;font-family:仿宋">（六）联盟成员有义务向联盟反映中小企业服务进展情况，提出合理化建议；</span>
</p>
<p style="text-align:left;text-indent:37px">
    <span style="font-size:19px;font-family:仿宋">（七）联盟成员应指派自身机构专员负责联盟的联络对接。</span>
</p>
<p style="text-align:left;text-indent:37px">
    <strong><span style="font-size:19px;font-family:仿宋">第十条</span></strong><span style="font-size: 19px;font-family:仿宋"> 加入联盟程序</span>
</p>
<p style="text-align:left;text-indent:37px">
    <span style="font-size:19px;font-family:仿宋">（一）由法定代表人或授权代表人提交申请登记表；</span>
</p>
<p style="text-align:left;text-indent:37px">
    <span style="font-size:19px;font-family:仿宋">（二）需提供法人资格证明文件的复印件、单位基本情况介绍等资料；</span>
</p>
<p style="text-align:left;text-indent:37px">
    <span style="font-size:19px;font-family:仿宋">（三）经联盟理事会审核通过后批准；</span>
</p>
<p style="text-align:left;text-indent:37px">
    <span style="font-size:19px;font-family:仿宋">（四）由联盟理事会颁发成员证书。</span>
</p>
<p style="text-align:left;text-indent:37px">
    <strong><span style="font-size:19px;font-family:仿宋">第十一条 </span></strong><span style="font-size: 19px;font-family:仿宋">退出联盟程序 </span>
</p>
<p style="text-align:left;text-indent:37px">
    <span style="font-size:19px;font-family:仿宋">（一）联盟成员应以书面形式向联盟提出申请并交回联盟成员证书、成员资格即终止；</span>
</p>
<p style="text-align:left;text-indent:37px">
    <span style="font-size:19px;font-family:仿宋">（二）联盟成员若出现严重违反联盟章程，损害联盟名誉的情况，经查实无误的报理事会同意，取消其成员资格； </span>
</p>
<p style="text-align:left;text-indent:37px">
    <span style="font-size:19px;font-family:仿宋">（三）联盟成员连续一年不参加联盟大会及相关活动，视为自动退出联盟。</span>
</p>
<p style="text-align:left;text-indent:37px">
    <span style="font-size:19px;font-family: 仿宋">&nbsp;</span>
</p>
<p style="text-align:center;text-indent:43px">
    <strong><span style="font-size:21px;font-family:仿宋">第四章 组织机构</span></strong>
</p>
<p style="text-align:left;text-indent:37px">
    <strong><span style="font-size:19px;font-family:仿宋">第十二条</span></strong><span style="font-size: 19px;font-family:仿宋"> 本联盟的最高权力机构是理事代表大会。理事代表大会由发起单位、联合发起单位、理事长单位、副理事长单位、专家顾问、理事单位组成。理事代表大会行使下列职权：</span>
</p>
<p style="text-align:left;text-indent:37px">
    <span style="font-size:19px;font-family:仿宋">（一）制定和修改本联盟章程；</span>
</p>
<p style="text-align:left;text-indent:37px">
    <span style="font-size:19px;font-family:仿宋">（二）选举和罢免本联盟的理事长、副理事长、聘任秘书处秘书长；</span>
</p>
<p style="text-align:left;text-indent:37px">
    <span style="font-size:19px;font-family:仿宋">（三）审议本会理事会工作报告；</span>
</p>
<p style="text-align:left;text-indent:37px">
    <span style="font-size:19px;font-family:仿宋">（四）表决通过本联盟的终止；</span>
</p>
<p style="text-align:left;text-indent:37px">
    <span style="font-size:19px;font-family:仿宋">（五）决定其他重大事宜。</span>
</p>
<p style="text-align:left;text-indent:37px">
    <strong><span style="font-size:19px;font-family:仿宋">第十三条</span></strong><span style="font-size: 19px;font-family:仿宋"> 理事代表大会原则上每年召开一次，理事代表大会须有2/3以上理事代表出席方能召开，其决议须获得到普通理事代表半数以上赞成方能生效。情况特殊时，如理事长提议或2/3以上理事提议，可以临时召开理事代表大会，紧急时，可采取通讯方式召开。</span>
</p>
<p style="text-indent:37px">
    <strong><span style="font-size:19px;font-family: 仿宋">第十四条 </span></strong><span style="font-size:19px;font-family:仿宋">本联盟在北京设秘书处，秘书处为理事会代表大会的执行机构，在理事会代表大会闭会期间领导本联盟开展日常工作，并对理事代表大会负责。秘书处成员每届任期1年，可连选连任。秘书处行使下列职权： </span>
</p>
<p style="text-align:left;text-indent:37px">
    <span style="font-size:19px;font-family:仿宋">（一）拟定章程及修正案草案；</span>
</p>
<p style="text-align:left;text-indent:37px">
    <span style="font-size:19px;font-family:仿宋">（二）管理联盟的所有文件档案和其他资料；</span>
</p>
<p style="text-align:left;text-indent:37px">
    <span style="font-size:19px;font-family:仿宋">（三）组织实施联盟工作计划，并负责联盟的宣传；</span>
</p>
<p style="text-align:left;text-indent:37px">
    <span style="font-size:19px;font-family:仿宋">（四）负责联盟成员间的联络工作，处理联盟的日常事务；</span>
</p>
<p style="text-align:left;text-indent:37px">
    <span style="font-size:19px;font-family:仿宋">（五）审核和接纳新成员，受理成员退出联盟的申请；</span>
</p>
<p style="text-align:left;text-indent:37px">
    <span style="font-size:19px;font-family:仿宋">（六）收集、整理、发布、对接联盟成员服务意向及需求；</span>
</p>
<p style="text-align:left;text-indent:37px">
    <span style="font-size:19px;font-family:仿宋">（七）向联盟成员推荐符合要求的服务项目；</span>
</p>
<p style="text-align:left;text-indent:37px">
    <span style="font-size:19px;font-family:仿宋">（八）负责组织安排联盟成员的沟通活动；</span>
</p>
<p style="text-align:left;text-indent:37px">
    <span style="font-size:19px;font-family:仿宋">（九）处理其他日常事务。</span>
</p>
<p style="text-align:left;text-indent:37px">
    <strong><span style="font-size:19px;font-family:仿宋">第十五条</span></strong><span style="font-size: 19px;font-family:仿宋"> 本联盟设理事长一名、副理事长、专家顾问若干名。理事长和副理事长按本会章程规定的程序选举产生。理事长、副理事长每届任期2年，连任不超过两届。</span>
</p>
<p style="text-indent:36px">
    <strong><span style="font-size:19px;font-family:仿宋">第十六条 </span></strong><span style="font-size:19px;font-family:仿宋">本联盟理事长、副理事长、专家顾问必须具备下列条件：</span>
</p>
<p style="text-indent:36px">
    <span style="font-size:19px;font-family:仿宋">（一） 拥护和执行党和国家的路线、方针、政策和法律法规，具有完全民事行为能力，有高度的事业心和责任感，政治素质好；</span>
</p>
<p style="text-indent:36px">
    <span style="font-size:19px;font-family:仿宋">（二） 认真学习、宣传、贯彻国家关于鼓励、支持、引导中小企业信用体系建设的有关法律法规，了解和熟悉中小企业现状，热心支持中小企业的健康发展；</span>
</p>
<p style="text-indent:36px">
    <span style="font-size:19px;font-family:仿宋">（三）未受过剥夺政治权利的刑事处罚，且在联盟业务领域内有较大影响； </span>
</p>
<p style="text-indent:36px">
    <span style="font-size:19px;font-family:仿宋">（四）最高任职年龄不超过70周岁，理事长、副理事长超过最高任职年龄的，须经理事代表大会审议通过，；</span>
</p>
<p style="text-indent:36px">
    <span style="font-size:19px;font-family:仿宋">（五）身体健康，有较强的组织、协调和决策能力，能胜任本职工作。</span>
</p>
<p style="text-indent:36px">
    <strong><span style="font-size:19px;font-family:仿宋">第十七条</span></strong><span style="font-size:19px;font-family:仿宋"> 理事长、副理事长因特殊原因不能按时换届需延长任期的，必须经理事代表大会2/3以上（含2/3）会员表决通过方可任职。</span>
</p>
<p style="text-indent:36px">
    <strong><span style="font-size:19px;font-family:仿宋">第十八条 </span></strong><span style="font-size:19px;font-family:仿宋">理事长为本联盟法定代表人，不兼任其他社会团体的法定代表人。理事长行使下列职权：</span>
</p>
<p style="text-indent:36px">
    <span style="font-size:19px;font-family:仿宋">（一）召集和主持理事代表大会、常务理事会和理事办公会；</span>
</p>
<p style="text-indent:36px">
    <span style="font-size:19px;font-family:仿宋">（二）代表本联盟签署有关重要文件；</span>
</p>
<p style="text-indent:36px">
    <span style="font-size:19px;font-family:仿宋">（三）检查会员理事代表大会、常务理事会决议的落实情况；</span>
</p>
<p style="text-indent:36px">
    <span style="font-size:19px;font-family:仿宋">（四）经理事代表大会或常务理事会审议批准，任免秘书长、办事机构、分支机构、代表机构和实体机构主要负责人；</span>
</p>
<p style="text-indent:36px">
    <span style="font-size:19px;font-family:仿宋">（五）决定联盟的其他重大事项，代表本联盟参加重大活动。</span>
</p>
<p style="text-indent:36px">
    <strong><span style="font-size:19px;font-family:仿宋">第十九条 </span></strong><span style="font-size:19px;font-family:仿宋">实行理事长办公会制度。理事长办公会议一般每月召开一次，由理事长、副理事长、委员长、副委员长和秘书处组成，需2/3以上成员出席，出席人员2/3以上同意，通过会议决议。理事长办公会议由理事长或受理事长委托的副理事长主持，研究决定提交常务理事会审议的事项。经常务理事会授权，代理行使下列其部分职能：</span>
</p>
<p style="text-indent:36px">
    <span style="font-size:19px;font-family:仿宋">（一）执行理事代表大会的决议；</span>
</p>
<p style="text-indent:36px">
    <span style="font-size:19px;font-family:仿宋">（二）筹备召开理事代表大会；</span>
</p>
<p style="text-indent:36px">
    <span style="font-size:19px;font-family:仿宋">（三）执行理事代表大会决议，向理事代表大会报告工作；</span>
</p>
<p style="text-indent:36px">
    <span style="font-size:19px;font-family:仿宋">（四）提出理事代表大会和常务理事会需要讨论的各种议案；</span>
</p>
<p style="text-indent:36px">
    <span style="font-size:19px;font-family:仿宋">（五）提名秘书长人选，报理事会或常务理事会审议；</span>
</p>
<p style="text-indent:36px">
    <span style="font-size:19px;font-family:仿宋">（六）制定行业自律制度并监督执行；</span>
</p>
<p style="text-indent:36px">
    <span style="font-size:19px;font-family:仿宋">（七）领导本联盟各机构开展工作；</span>
</p>
<p style="text-indent:36px">
    <span style="font-size:19px;font-family:仿宋">（八）制定本会内部管理制度。</span>
</p>
<p style="text-indent:36px">
    <strong><span style="font-size:19px;font-family:仿宋">第二十条</span></strong><span style="font-size:19px;font-family:仿宋"> 秘书长行使下列职权：</span>
</p>
<p style="text-indent:36px">
    <span style="font-size:19px;font-family:仿宋">（一）对理事代表大会、理事长办公会和理事长负责，定期向理事长办公会报告工作；</span>
</p>
<p style="text-indent:36px">
    <span style="font-size:19px;font-family:仿宋">（二）主持办事机构开展日常工作，组织实施年度工作计划；</span>
</p>
<p style="text-indent:36px">
    <span style="font-size:19px;font-family:仿宋">（三）协调各分支机构、代表机构和实体机构开展工作；</span>
</p>
<p style="text-indent:36px">
    <span style="font-size:19px;font-family:仿宋">（四）处理其他日常事务。</span>
</p>
<p style="text-indent:36px">
    <strong><span style="font-size:19px;font-family:仿宋">第二十一条 </span></strong><span style="font-size:19px;font-family:仿宋">秘书处为本会常设办事机构。</span>
</p>
<p style="text-indent:36px">
    <strong><span style="font-size:19px;font-family:仿宋">第二十二条 </span></strong><span style="font-size:19px;font-family:仿宋">根据工作需要，经有关部门批准，本联盟可设立分支机构、代表机构和实体机构，从事各项专业活动，承担本联盟交办的工作。分支机构名称为分会、专业委员会、工作委员会等；代表机构名称为代表处、办事处、联络处等。 </span>
</p>
<p style="text-indent:36px">
    <strong><span style="font-size:19px;font-family:仿宋">第二十三条 </span></strong><span style="font-size:19px;font-family:仿宋">分支机构、代表机构和实体机构负责人，可作为特邀代表出席理事代表大会。理事会、理事长办公会根据需要，可特邀部分分支机构、代表机构和实体机构负责人列席。</span>
</p>
<p style="text-align:left;text-indent:37px">
    <strong><span style="font-size:19px;font-family:仿宋">第二十四条 </span></strong><span style="font-size:19px;font-family:仿宋">联盟各成员指派一名联络员代表，负责与联盟理事会的日常联络工作。联盟成员联络员的具体职责包括： </span>
</p>
<p style="text-align:left;text-indent:37px">
    <span style="font-size:19px;font-family:仿宋">（一）参加联盟的各项活动，承担联盟委托的工作；</span>
</p>
<p style="text-align:left;text-indent:37px">
    <span style="font-size:19px;font-family:仿宋">（二）及时反馈联盟成员的需求及对联盟工作的建议；</span>
</p>
<p style="text-align:left;text-indent:37px">
    <span style="font-size:19px;font-family:仿宋">（三）及时、准确地向联盟提供不涉及商业秘密的服务信息资料；</span>
</p>
<p style="text-align:left;text-indent:37px">
    <span style="font-size:19px;font-family:仿宋">（四）协助联盟理事会完成有关企业的服务工作；</span>
</p>
<p style="text-align:left;text-indent:37px">
    <span style="font-size:19px;font-family:仿宋">（五）负责完成联盟委托的其他工作。</span>
</p>
<p style="text-align:center;text-indent:43px">
    <strong><span style="font-size:21px;font-family:仿宋">第五章 章程的修改程序</span></strong>
</p>
<p style="text-align:left;text-indent:37px">
    <strong><span style="font-size:19px;font-family:仿宋">第二十五条 </span></strong><span style="font-size:19px;font-family:仿宋">联盟章程的修改，经联盟理事代表大会审议表决通过后生效。</span>
</p>
<p style="text-align:center;text-indent:43px">
    <strong><span style="font-size:21px;font-family:仿宋">第六章 终止程序</span></strong>
</p>
<p style="text-align:left;text-indent:37px">
    <strong><span style="font-size:19px;font-family:仿宋">第二十六条 </span></strong><span style="font-size:19px;font-family:仿宋">本联盟完成宗旨、自行解散或由于分立、合并等原因需要注销的由常务理事会提出终止动议。</span>
</p>
<p style="text-align:left;text-indent:37px">
    <strong><span style="font-size:19px;font-family:仿宋">第二十七条</span></strong><span style="font-size: 19px;font-family:仿宋"> 本联盟终止动议须经理事代表大会表决通过。</span>
</p>
<p style="text-align:left;text-indent:37px">
    <strong><span style="font-size:19px;font-family:仿宋">第二十八条 </span></strong><span style="font-size:19px;font-family:仿宋">本联盟终止前，须在理事代表大会的指导监督下，处理善后事宜。</span>
</p>
<p style="text-align:center;text-indent:43px">
    <strong><span style="font-size:21px;font-family:仿宋">第七章 附 则</span></strong>
</p>
<p style="text-indent:37px">
    <strong><span style="font-size:19px;font-family: 仿宋">第二十九条</span></strong><span style="font-size:19px;font-family:仿宋"> 本章程经联盟理事代表大会第一次会议表决通过生效。</span>
</p>
<p style="text-indent:37px">
    <strong><span style="font-size:19px;font-family: 仿宋">第三十条</span></strong><span style="font-size:19px;font-family:仿宋"> 本章程的解释权属本联盟的理事代表大会。</span>
</p>
<p>
    <br/>
</p></div>
</template>

<script>
export default {
  name: 'lmzc'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/computer/lmzc.vue